import { useState } from 'react';
import { Phone } from 'lucide-react';
import { publicRequest } from '../../requestMethods';
import './PhonePromptModal.scss';

const PhonePromptModal = ({ user, onClose, onSaved }) => {
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const validatePhone = (value) => {
        const cleaned = value.replace(/\D/g, '');
        return cleaned.length >= 10;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!phone.trim()) {
            setError('Please enter your mobile number');
            return;
        }
        if (!validatePhone(phone)) {
            setError('Please enter a valid 10-digit mobile number');
            return;
        }
        setLoading(true);
        try {
            await publicRequest.patch('/users/profile', {
                email: user.email,
                name: user.name,
                googleId: user.sub || user.googleId,
                picture: user.picture,
                phone: phone.trim(),
            });
            const updatedUser = { ...user, phone: phone.trim() };
            localStorage.setItem('user', JSON.stringify(updatedUser));
            window.dispatchEvent(new Event('userUpdated'));
            onSaved?.(updatedUser);
            onClose?.();
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to save. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="phone-prompt-overlay" onClick={onClose}>
            <div className="phone-prompt-modal" onClick={(e) => e.stopPropagation()}>
                <div className="phone-prompt-header">
                    <Phone size={28} />
                    <h3>Add Your Mobile Number</h3>
                    <p>We'd like to capture your mobile number for better communication. It helps us reach you when needed.</p>
                </div>
                <form onSubmit={handleSubmit} className="phone-prompt-form">
                    <label>
                        Mobile Number
                        <input
                            type="tel"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="e.g. 9876543210"
                            maxLength={15}
                            disabled={loading}
                        />
                    </label>
                    {error && <div className="phone-prompt-error">{error}</div>}
                    <div className="phone-prompt-actions">
                        <button type="button" className="btn-skip" onClick={onClose} disabled={loading}>
                            Skip for now
                        </button>
                        <button type="submit" className="btn-save" disabled={loading}>
                            {loading ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PhonePromptModal;
